import { Group, Section } from '../../components/Manager/DatasetForm/types';

export const createOrganizationUnit = <T>(
  unit: Group | Section,
  type: 'group' | 'section'
): T => {
  return {
    ...unit,
    type,
    items: new Map(),
    visible: Object.hasOwn(unit, 'visible') ? unit.visible : true,
    allowVisible: Object.hasOwn(unit, 'allowVisible')
      ? unit.allowVisible
      : true,
  } as T;
};
